var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 75,
    viewBox: "0 0 62 75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.891 74.8298L61.2905 2.18917C51.9049 1.2888 41.5788 0.722048 30.4367 0.738126C19.6443 0.754204 9.62366 1.31694 0.487305 2.18917C10.6205 26.4027 20.7537 50.6163 30.8869 74.8298H30.891Z",
    fill: "url(#paint0_radial_3779_64440)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.891 5.03537C38.9179 5.03537 47.0212 5.3489 55.0522 5.96388L30.8869 63.7002L19.6484 36.8498L6.72157 5.96388C14.6079 5.35693 22.5625 5.04341 30.4407 5.03537H30.8869M30.8869 0.738514C30.7382 0.738514 30.5854 0.738514 30.4367 0.738514C19.6443 0.754592 9.62366 1.31732 0.487305 2.18956C10.6205 26.4031 20.7537 50.6167 30.8869 74.8302L61.2865 2.18956C52.0295 1.30125 41.8522 0.734497 30.8869 0.734497V0.738514Z",
    fill: "url(#paint1_radial_3779_64440)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3779_64440",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.54444 32.6691) scale(139.188 139.188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF8200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF7200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7A00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3779_64440",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.8909 37.7823) scale(33.8885 33.8885)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFA34F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF9D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FF9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFA84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFCA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFCF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFCF4F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinPin);
export default __webpack_public_path__ + "static/media/spin-pin.d379c4a7616bd7e2d3860b9b59467acf.svg";
export { ForwardRef as ReactComponent };